import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {Column, Row} from "react-vcomponents";
import {ES, ErrorBoundary} from "web-vcore";
import {DMap} from "../../Server/DB/maps/@Map.js";
import {MapState} from "../../Store/main/maps/@MapState.js";
import {colors} from "../../Utils/UI/GlobalStyles.js";
import {MapSurface} from "./MapUI/MapSurface.js";
import {MenuBar} from "./MapUI/MenuBar.js";
import {ReferencesUI} from "./MapUI/Toolbox/ReferencesUI.js";
import {ToolboxUI} from "./MapUI/Toolbox/ToolboxUI.js";
import {MapSidebar} from "./MapUI/MapSidebar.js";

/*export const MapUIWaitMessage = observer_mgl((props: {message: string})=>{
	const {message} = props;
	return (
		<div style={ES({
			display: "flex", alignItems: "center", justifyContent: "center", flex: 1, fontSize: 25,
			//textShadow: "#000 0px 0px 1px,   #000 0px 0px 1px,   #000 0px 0px 1px, #000 0px 0px 1px,   #000 0px 0px 1px,   #000 0px 0px 1px",
			color: "white",
			textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
		})}>
			{message}
		</div>
	);
});*/

export const MapUI = observer_mgl(({map, mapState}: {map: DMap, mapState: MapState})=>{
	return (
		<Row style={ES({flex: 1})}>
				<MapBackground {...{map, mapState}}/>
			<MapSidebar {...{map, mapState}}/>
		</Row>
	);
});

const MapBackground = observer_mgl(({map, mapState}: {map: DMap, mapState: MapState})=>{
	return (
		<Column style={{
			position: "relative",
			flex: 80,
			//backgroundColor: "hsl(0,0%,20%)",
			backgroundColor: colors.mapUI_background,
		}}>
			<ErrorBoundary>
				<MenuBar {...{map, mapState}} />
				<ToolboxUI {...{map, mapState}}/>
				{mapState.settings.general.showReferences && <ReferencesUI {...{map, mapState}}/>}
				{/* ?3d=off — TEMP DEBUG: fully skip mounting MapSurface (the R3F <Canvas>/WebGL renderer) so the
				    integrated-browser can stay alive while debugging its GL crash/blackout. */}
				{startURL.GetQueryVar("3d") == "off" ? null :
				<MapSurface {...{map, mapState}} />}
			</ErrorBoundary>
		</Column>
	);
});